// src/components/public/choices.js
// This is the choices component that is used in forms

export const COUNTRY_CHOICES = [
    { value: "IN", label: "India" },
    { value: "US", label: "United States" },
    { value: "CA", label: "Canada" },
    { value: "UK", label: "United Kingdom" },
    { value: "DE", label: "Germany" },
    { value: "JP", label: "Japan" },
    { value: "AU", label: "Australia" },
    { value: "NZ", label: "New Zealand" },
    { value: "ID", label: "Indonesia" },
    { value: "FR", label: "France" },
];

export const CURRENCY_CHOICES = [
    { value: "USD", label: "USD" },
    { value: "EUR", label: "EUR" },
    { value: "INR", label: "INR" },
    { value: "GBP", label: "GBP" },
    { value: "CHF", label: "CHF" },
    { value: "JPY", label: "JPY" },
]

export const LANGUAGE_CHOICES = [
    { value: "en", label: "English" },
    { value: "fr", label: "French" },
    { value: "de", label: "German" },
    { value: "it", label: "Italian" },
    { value: "es", label: "Spanish" },
]

export const UNITS_OF_MEASURE_CHOICES = [
    { value: "METRIC", label: "Metric" },
    { value: "IMPERIAL", label: "Imperial" },
]